// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.

import { useContext } from 'react';
import { VolumeContext } from '@/context/call-context/volume-context';

// MUST BE USED WITH CALL, auth
export const useVolume = () => useContext(VolumeContext);
